const tasks: (() => void)[] = [];
export function microTasks(fn: () => void, shift: boolean = false) {
  if (tasks.length === 0) {
    queueMicrotask(runAll);
  }
  shift ? tasks.unshift(fn) : tasks.push(fn);
}

function runAll() {
  const removed = tasks.splice(0);
  for (const fn of removed) {
    fn();
  }
}
